export default "/palm/assets/images/icon-right.svg"